import React from 'react'
import { Dialog, Pane, Button, Strong, Heading } from 'evergreen-ui'

import { connect } from 'react-redux'
import DayPicker from './dayPicker'

import EditCard from './editCard'

class EditPrice extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      pricingConfig: ''
    }
    this.baseState = this.state
  }

  async componentDidMount () {
    // await this.setStateWithReceivedPriceData();
  }

  // setStateWithReceivedPriceData = async () => {
  // 	await this.setState({
  // 		startDay: this.state.daysData["tuesday"],
  // 		endDay: this.state.daysData["tuesday"],
  // 	});
  // };

  onCloseDialog = async () => {
    const { editPrice } = this.props

    this.setState({
      ...this.baseState
    })

    editPrice(false)
  }

  render () {
    const {
      isShown,
      pricing,
      addSlot,
      handleAddDiscountSlot,
      handleRemoveDiscountSlot,
      removeSlot,
      mutateVolumeDiscount,
      mutateDiscount,
      mutateHourlyPrice,
      mutateTime,
      handleEndDayChange,
      handleStartDayChange,
      startDay,
      endDay,
      holiday,
      onConfirm,
      isInvalid
    } = this.props

    let indexA = pricing && pricing.priceSlots && pricing.priceSlots.length
  
    return (
      <Dialog
        isShown={isShown}
        intent='success'
        onConfirm={onConfirm}
        confirmLabel={'Save Changes'}
        hasHeader={false}
        topOffset={-5}
        sideOffset={0}
        onCloseComplete={this.onCloseDialog}
      >
        <Pane padding={15} margin={-16} background='tint2' minHeight='105vh'>
          <Pane
            marginBottom={20}
            display={'flex'}
            flexDirection={'row'}
            alignItems={'center'}
            justifyContent={'space-between'}
          >
            <Strong marginTop={10} size={500}>
              Pricing Details
            </Strong>
          </Pane>
          {!holiday ? (
            <Pane
              marginTop={16}
              display={'flex'}
              justifyContent={'space-between'}
            >
              <Pane
                marginRight={10}
                display={'flex'}
                flexDirection={'column'}
                width={'50%'}
              >
                <Heading marginBottom={4} size={400} color={'#425A70'}>
                  From
                </Heading>
                <DayPicker
                  selectedDayId={startDay}
                  changeDay={handleStartDayChange}
                />
              </Pane>
              <Pane
                marginLeft={10}
                display={'flex'}
                flexDirection={'column'}
                width={'50%'}
              >
                <Heading marginBottom={4} size={400} color={'#425A70'}>
                  To
                </Heading>
                <DayPicker
                  selectedDayId={endDay}
                  changeDay={handleEndDayChange}
                />
              </Pane>
            </Pane>
          ) : (
            <Strong size={400}>Holiday</Strong>
          )}

          {pricing
            ? pricing.priceSlots.map((pricing, index) => {
                return (
                  <EditCard
                    isInvalid={isInvalid}
                    handleAddDiscountSlot={handleAddDiscountSlot}
                    handleRemoveDiscountSlot={handleRemoveDiscountSlot}
                    indexB={index}
                    pricing={pricing}
                    mutateVolumeDiscount={mutateVolumeDiscount}
                    mutateDiscount={mutateDiscount}
                    mutateHourlyPrice={mutateHourlyPrice}
                    mutateTime={mutateTime}
                  />
                )
              })
            : null}

          <Pane
            display={'flex'}
            flexDirection={'row'}
            justifyContent={'flex-end'}
            alignItems={'flex-end'}
            marginTop={10}
            marginTop={5}
          >
            {indexA != 1 ? (
              <Button
                height={30}
                width={70}
                marginRight={10}
                appearance='minimal'
                intent='danger'
                style={{ border: '1px solid red' }}
                onClick={() => removeSlot(indexA)}
              >
                Delete
              </Button>
            ) : null}
            <Button
              appearance='primary'
              width={60}
              height={30}
              onClick={() => addSlot()}
            >
              Add
            </Button>{' '}
          </Pane>
        </Pane>
      </Dialog>
    )
  }
}

const mapStateToProps = ({ deskUserData }) => ({
  deskUserData
})

export default connect(mapStateToProps)(EditPrice)
